<template>
  <div class="home">
    <div class="nav">
      <div :class="index===0 ? 'left':index===1 ?'center':index ===2 ? 'center2':'right'" v-for="(item,index) in Statistics" :key="`${index}a`">
        <el-row>
          <el-col :span="12">
           {{item.title}}
          </el-col>
          <el-col :span="12" style="text-align: end">
           <el-select filterable :class="index===0 ?'percentage1': index === 1 ? 'percentage2':index ===2?'percentage3':'percentage4'"
                      v-if="index !==0" size="mini" v-model="item.type" style="width: 90px;" :popper-append-to-body="false" @change="selectChange(item,index)">
             <el-option value="1" label="本周"></el-option>
             <el-option value="2" label="本月"></el-option>
             <el-option value="3" label="本季"></el-option>
           </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="index===1 ?8 :12" style="font-size: 14px; ">
            {{item.field}}
          </el-col>
          <el-col :span="index===1?8:12" style="font-size: 14px; ">
            {{item.field2}}
          </el-col>
          <el-col :span="8" style="font-size: 14px; " v-if="index===1" >
            {{item.field3}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="index ===1? 8 :12" >
<!--            <div :class="index ===0 ? 'percentage1':index === 1 ? 'percentage2':index ===2?'percentage3':'percentage4'">{{item.percentage}}</div>-->
            <span style="margin-left: 32px;">{{item.number}}</span>

          </el-col>
          <el-col :span="index ===1?8:12" >
            <span style="margin-left: 32px;">{{item.contrast}}</span>

          </el-col>
          <el-col :span="8" v-if="index ===1">
            <span style="margin-left: 32px;">{{item.percentage}}</span>

          </el-col>
        </el-row>
      </div>
<!--      <div class="center"></div>-->
<!--      <div class="center2"></div>-->
<!--      <div class="right"></div>-->
    </div>
    <div class="homeCenter">
      <div class="CenterRight">
        <div class="title">整车统计</div>
        <homeLineEcharts :xdata="LineEchartData.Xdata" :ydata="LineEchartData.Ydata"></homeLineEcharts>
      </div>
      <div class="CenterLeft">
        <div class="title">客户订单统计</div>
        <homeBarEcharts :xdata="BarEchartsData.Xdata" :ydata="BarEchartsData.Ydata"></homeBarEcharts>
      </div>

    </div>
    <div class="homeCenter" v-has="'pc_home_contractWarning'">
      <div class="CenterRight">
          <p>合同预警</p>
          <homeEarlyWarning ref="homeEarlyWarning"></homeEarlyWarning>
      </div>
      <div class="footerCenter"></div>
      <div class="footerRight"></div>
    </div>
    <el-dialog title="修改密码"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      width="500px">
      <div class="dialogContainer">
        <el-form :model="form" ref="formRef" label-width="96px" :rules="rulesModify">
          <el-form-item prop="newPwd" label="新密码：">
            <el-input v-model="form.newPwd" placeholder="请输入新密码" autocomplete="off" size="small" type="password"/>
          </el-form-item>
          <el-form-item prop="cofPwd" label="确认密码：">
            <el-input v-model="form.cofPwd" placeholder="请再次输入新密码" autocomplete="off" size="small" type="password"/>
          </el-form-item>
          <div class="form-btn">
            <el-button @click="changePwdCof" type="primary" size="small">确认</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  applicationAreaInfo,
  homePageGetData
} from "@/service/getData";
import {setSessionStore} from "@/config/mUtils";
import homeLineEcharts from '@/components/homeLineEcharts';
import homeBarEcharts from '@/components/homeBarEcharts';
import { getSessionStore } from "@/config/mUtils"
import {updatePasswordOne} from "@/service/getData"
import homeEarlyWarning from '@/components/homeEarlyWarning'

export default {
  components: {
    homeLineEcharts,
    homeBarEcharts,
    homeEarlyWarning,
  },

  data() {
    let validatorPwd = (rule, value, callback) => {
      if(value.length < 6||value.length > 16) {
        callback(new Error('密码为长度为6-16位'));
      }else{
        callback();
      }
    };
    // 验证两次输入密码是否正确
    let ModifyPass = (rule, value, callback) => {
      if(value.length < 6||value.length > 16) {
        callback(new Error('密码为长度为6-16位'));
      } else if (value !== this.form.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      Statistics:[
        {title:'商务合规',field:'合同待审核',field2:'新增合同',number:'0',percentage:'0',contrast:'0',class:'left',type:'1'},
        {title:'整车物流',field:'新增计划量',field2:'公路交车量',field3:'水路交车量',number:'0',
          percentage:'0',contrast:'0',class:'center',type:'1',
        },
        {title:'对账结算',field:'待结算金额',field2:'已结算金额',number:'0',percentage:'0',contrast:'0',class:'center2',type:'1'},
        {title:'财务',field:'支出金额',field2:'收入出金额',number:'0',percentage:'0',contrast:'0',class:'right',type:'1'},
      ],
      LineEchartData:{
        Xdata:['本月','9月','8月','7月','6月','5月','4月','3月','2月','1月','12月','12月'],
        Ydata:{}
      },
      BarEchartsData:{
        Xdata:['本月','9月','8月','7月','6月','5月','4月','3月','2月','1月','12月','11月'],
        Ydata:['0','0','0','0','0','0','0','0','0','0','0','0'],
      },
      res:{},
      // 修改密码弹窗
      dialogVisible: false,
      isUpdatePwd:1,
      form:{
        newPwd:'',
        cofPwd:'',
      },
      indexPath:'basicfile',
      // 修改密码验证表单
      rulesModify:{
        pwd:[
          { required: true, message: '旧密码不能为空', trigger: 'blur' },
        ],
        newPwd:[
          { required: true, validator: validatorPwd, trigger: 'blur' },
        ],
        cofPwd:[
          { required: true, validator: ModifyPass, trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    this.$refs.homeEarlyWarning._contractPageList();
    if(this.$route.query.first){
      // this._getAreaList();
    }
    // this._homePageGetData()
    this.isUpdatePwd = getSessionStore("isUpdatePwd");
    if(this.isUpdatePwd==0) {
      this.dialogVisible = true;
    }
  },
  methods: {
    async _getAreaList() {
      let res = await applicationAreaInfo();
      if (res.status === 0) {
        if (res.data) {
          setSessionStore("areaList", res.data);
        }
      } else this.$message.error(res.message);
    },
    async _homePageGetData(){
      let res = await homePageGetData()
      if (res.status !==0) return this.$message.error(res.message)
      this.res =res.data
      // 表月度完成
      let data1=res.data.monthCount
      console.log(data1)
      //公路车辆调配
      let data2=res.data.roadCount
      // 水路车辆调配
      let data3=res.data.shipCount
      this.LineEchartData.Ydata={
        data1:data1,
        data2:data2,
        data3:data3
      }
      this.Statistics[0].number = res.data.contractCount1
      this.Statistics[0].contrast = res.data.contractCount2
      this.Statistics[1].number = res.data.planWeekCount
      this.Statistics[1].contrast = res.data.roadWeekCount
      this.Statistics[1].percentage = res.data.shipWeekCount

      console.log(this.LineEchartData.Ydata)
      let date = new Date()
      let arrays = []
      let month = date.getMonth() +1
      for (let a=0;a <12 ;a++){
        if (month ===date.getMonth() +1 ){
          arrays.push('本月')
          month--
        }else if (month ===0){ //回归12月
          month = 12
          arrays.push(`${month}月`)
        }else {
          month--
          arrays.push(`${month}月`)
        }

      }
      this.LineEchartData.Xdata = arrays
      this.BarEchartsData.Xdata = arrays




    },
    selectChange(item,index){
      if (index===1 && item.type==="1"){
        this.Statistics[index].number = this.res.planWeekCount
        this.Statistics[index].contrast = this.res.roadWeekCount
        this.Statistics[index].percentage = res.data.shipWeekCount
      }else if (index ===1 && item.type==="2"){
        this.Statistics[index].number = this.res.planMonthCount
        this.Statistics[index].contrast = this.res.roadMonthCount
        this.Statistics[index].percentage = res.data.shipMonthCount
      }else if (index ===1 && item.type==="3"){
        this.Statistics[index].number = this.res.planQuarterCount
        this.Statistics[index].contrast = this.res.roadQuarterCount
        this.Statistics[index].percentage = res.data.shipQuarterCount
      }


    },
    // 修改密码
    async changePwdCof(){
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          let obj = 'pwd='+this.form.newPwd;
          let res = await updatePasswordOne(obj);
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.isUpdatePwd = 1;
          setSessionStore("isUpdatePwd", this.isUpdatePwd);
          this.dialogVisible=false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>



<style lang="scss" scoped>
.home{
  padding: 30px;
  width: 100%;
  background-color: rgb(244, 247, 251);
  font-family: "Roboto", sans-serif;
  ::v-deep.nav{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    .el-row{
      margin-bottom: 1rem;
    }
    .el-select .el-input .el-select__caret {
      color: #f6f7fb;
    }
    .el-select-dropdown__item {
      padding: 0 30px;
    }
    .el-input__inner{
      color: white;
    }
    .percentage1{
      background: linear-gradient(to right, #296ed4, #2992d4);
      .el-input__inner{
        background: linear-gradient(to right, #296ed4, #2992d4);
      }
    }
    .percentage2{
      background: linear-gradient(to right, #47bd2a, #7bdc4e);
      .el-input__inner{
        background: linear-gradient(to right, #47bd2a, #7bdc4e);
      }
    }
    .percentage3{
      background: linear-gradient(to right, #ff8a32, #ffb051);
      .el-input__inner{
        background: linear-gradient(to right, #ff8a32, #ffb051);
      }
    }
    .percentage4{
      background: linear-gradient(to right, #385dea, #5c7aec);
      .el-input__inner{
        background: linear-gradient(to right, #385dea, #5c7aec);
      }
    }

    .left{
      width: 24%;
      background: linear-gradient(to right, #296ed4, #2992d4);
    }
    .center{
      width: 24%;
      background: linear-gradient(to right, #47bd2a, #7bdc4e);
    }
    .center2{
      width: 24%;
      background: linear-gradient(to right, #ff8a32, #ffb051);
    }
    .right{
      width: 24%;
      background: linear-gradient(to right, #385dea, #5c7aec);
    }
  }
  .nav>div{
    font-size: 1rem;
    color: white;
    height: 140px;
    margin-right: 30px;
    padding: 20px;
  }
  &Center{
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;

    .title{
      margin-bottom: 8px;
      text-transform: uppercase;
      letter-spacing: 0.02em;
      font-size: 14px;
      font-weight: 700;
      color: #797979;
    }
    .CenterRight{
      width: 59%;

    }
    .CenterLeft{
      width: 46%;
    }

  }
  &Center>div{
    background-color: #ffffff;
    width: 380px;
    height: 400px;
    margin-right: 30px;
    padding: 20px;
  }
  .footer{
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    div{
      background-color: #ffffff;
    }
    .footerLeft{
      margin-right: 22px;
      width: 53%;
      height: 400px;
    }
    p{
      margin: 20px 17px;
      text-transform: uppercase;
      letter-spacing: 0.02em;
      font-size: 14px;
      font-weight: 700;
      color: #797979;
    }
    .footerCenter{
      margin-right: 10px;
      margin-left: 10px;
      width: 520px;

    }
    .footerRight{
      margin-left: 22px;
    }

  }
  .form-btn { text-align: right; }
}
::v-deep {
  .el-dialog__body { padding: 30px 40px; }
}
</style>
